import { render, staticRenderFns } from "./ChatReply.vue?vue&type=template&id=57e8ed2e&scoped=true&"
import script from "./ChatReply.vue?vue&type=script&lang=js&"
export * from "./ChatReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatReply.vue?vue&type=style&index=0&id=57e8ed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8ed2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDialog,VIcon,VTextarea})
